/**
 * 从外接数据源获取的数据和本地数据的数据长度不一致，为了避免在更新本地数据的时候数组越界或者产生多余数据，需要先根据接口数据组装数据
 * 组装图例数据
 * 组装series中的data数据
 * 组装坐标轴中的data数据 x轴还是y轴需要看当前本地数据
 * @param {*} chartOption 图标组件的echarts的options
 * @param {*} charOptionTempSeries
 * @param {*} result
 * @param {*} defaultGradientColor
 * @param {*} defaultColor
 * @returns
 */
import { getErrorCode, simpleDeepClone } from "utils/index"
function assembleLocalData(chartOption, charOptionTempSeries, result, defaultGradientColor, defaultColor) {
  let localData = simpleDeepClone(charOptionTempSeries)
  let legendData = []
  let axisData = []
  let axisDataType = null
  //数据为空时的展位图逻辑有问题 很多地方没做空数据兼容
  if (result.length === 0) {
    //后台数据为空 直接返回空数据
    this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
    throw new Error(`当前组件:${this.$event.getIdsByStrId(this.myid)}的外接数据源appId:${this?.options?.appId}数据为空`)
  } else {
    this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
  }
  if (chartOption?.seriesTempAttributes?.coordinateType === "rectangular") {
    if (chartOption.xAxis.data.length && chartOption.xAxis.type === "category") {
      axisDataType = chartOption.xAxis.data[0]
    }
    if (chartOption.yAxis.data?.length && chartOption.yAxis.type === "category") {
      axisDataType = chartOption.yAxis.data[0]
    }
  } else if (chartOption?.seriesTempAttributes?.coordinateType === "polar") {
    if (chartOption.radiusAxis.data.length && chartOption.radiusAxis.type === "category") {
      axisDataType = chartOption.radiusAxis.data[0]
    }
  }
  // 同步series长度
  const lengthTemp = localData.length // localData数据长度会变，所以在外面初始化
  if (result.length > localData.length) {
    for (let i = 0; i < result.length - lengthTemp; i++) {
      let seriesItem = simpleDeepClone(localData[0])
      seriesItem.name = "数据" + (localData.length + 1)
      localData.push(seriesItem)
    }
  } else if (result.length < localData.length) {
    for (let i = 0; i < lengthTemp - result.length; i++) {
      localData.pop()
    }
  }
  for (let k = 0; k < localData.length; k++) {
    const localDataLength = localData[k].data.length // localData数据长度会变，所以在外面初始化
    if (result[k]?.data?.length > localData[k].data.length) {
      for (let j = 0; j < result[k].data.length - localDataLength; j++) {
        const cloneDataItem = simpleDeepClone(localData[k].data[0])
        // 设置默认样色
        if (
          cloneDataItem &&
          cloneDataItem.hasOwnProperty("itemStyle") &&
          JSON.stringify(cloneDataItem.itemStyle) !== "{}"
        ) {
          if (typeof cloneDataItem.itemStyle.color === "object") {
            cloneDataItem.itemStyle.color.colorStops[0].color =
              defaultGradientColor[(localDataLength + j) % defaultGradientColor.length][0]
            cloneDataItem.itemStyle.color.colorStops[1].color =
              defaultGradientColor[(localDataLength + j) % defaultGradientColor.length][1]
          } else {
            cloneDataItem.itemStyle.color = defaultColor[(localDataLength + j) % defaultColor.length]
          }
        }
        localData[k].data.push(cloneDataItem)
      }
    } else if (result[k]?.data?.length < localData[k].data.length) {
      for (let j = 0; j < localDataLength - result[k].data.length; j++) {
        localData[k].data.pop()
      }
    }
  }
  for (let m = 0; m < result.length; m++) {
    legendData.push(result[m].name ? result[m].name : "")
    localData[m].name = result[m].name
    localData[m].formatter = `{value}{valueUnit|${result[m].unit}`
    const dataItem = result[m].data || []
    let maxVal = 0,
      isBarStyle12 = false
    if (chartOption.series[0].type === "bar" && chartOption.styleId === 12) {
      isBarStyle12 = true
    }
    for (let n = 0; n < dataItem.length; n++) {
      // 不同系列的数据也应该共用一套坐标轴的数据
      //对轴数据单独处理
      if (typeof axisDataType === "object" && axisDataType !== null) {
        axisData[n] = simpleDeepClone(axisDataType)
        if (axisData[n].realValue) {
          axisData[n].realValue = dataItem[n].key
        } else {
          axisData[n].value = dataItem[n].key
        }
      } else {
        axisData[n] = dataItem[n].key
      }
      localData[m].data[n].value = dataItem[n].value
      if (localData[m].data[n].name !== undefined) {
        localData[m].data[n].name = dataItem[n].key
      }
      //  获取最大值
      if (isBarStyle12 && maxVal < Number(dataItem[n].value)) {
        maxVal = Number(dataItem[n].value)
      }
    }
    if (isBarStyle12) {
      //  柱状图样式12
      //  柱状图仅支持一组数据
      // 柱状图样式12仅支持一组数据，serires总4组，按照顺序为  中间柱状图，下面图标，上面图标，背景图标
      let seriesDataMax = []
      // 解决外接数据源数据大于本地数据导致报错的情况
      let len1 = chartOption.series[1].data.length
      if (len1 < dataItem.length) {
        for (let j = 0; j < dataItem.length - len1; j++) {
          chartOption.series[1].data.push(localData[m].data[len1 + j])
          chartOption.series[2].data.push(localData[m].data[len1 + j])
        }
      }
      for (let j = 0; j < dataItem.length; j++) {
        seriesDataMax.push(maxVal)
        chartOption.series[1].data[j].value = dataItem[j].value
        chartOption.series[2].data[j].value = dataItem[j].value
      }
      chartOption.series[1].name = localData[m].name
      chartOption.series[2].name = localData[m].name
      chartOption.series[3].data = seriesDataMax
      localData.push(chartOption.series[1])
      localData.push(chartOption.series[2])
      localData.push(chartOption.series[3])
    }
  }
  return { localData, legendData, axisData }
}

export function oldHandleChartData(chartOption, res, defaultGradientColor, defaultColor) {
  this.$changeOptionsEV("", "errorCode", false, null, this.myid, true)
  if (res.data.code === 1) {
    if (!res?.data?.data?.content?.data) {
      !this.isBigScreenPreview() && console.log("请求失败")
    } else {
      const result = res.data.data.content.data.filter(item => {
        return (item?.total && item.total > 0) || (Array.isArray(item?.data) && item.data.length > 0)
      })
      const charOptionTemp = simpleDeepClone(chartOption)
      this.$changeOptionsEV(res.data.data.publicId, "publicId", false, null, this.myid, true)
      // 雷达图单独处理
      if (charOptionTemp.series[0].type === "radar") {
        if (result.length < 1) {
          this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
          return
        } else {
          this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
        }
        // 需要判断数据条数不一致的情况
        // 数据源数据条数大于原始数据需要先在data里复制第一条数据进行追加
        let newSeriesArr = []
        for (let i = 0; i < result.length; i++) {
          // 这里设计存在问题，当series条数减少时，这个设置就会被丢掉了，以后series增加，只能按照第一条复制处理
          const newSeriesData = JSON.parse(
            JSON.stringify(charOptionTemp.series[0].data[i] || charOptionTemp.series[0].data[0])
          )
          newSeriesData.name = result[i].name
          newSeriesArr.push(newSeriesData)
        }
        this.$changeOptionsEV(newSeriesArr, "chartOption.series.0.data", false, null, this.myid, true)
        // 设置indicator数据
        let radarIndicator = simpleDeepClone(result[result.length - 1].data)
        /* 获取多维数据的最大值 */
        let maxVal = 0,
          hasMax = false,
          maxArr = []
        if (result[0].max) {
          hasMax = true
          for (let i = 0; i < result.length; i++) {
            maxArr.push(result[i].max)
          }
        }
        maxVal = Math.max.apply(null, maxArr)
        const newIndicator = radarIndicator.map(item => {
          return { name: item.key, max: item.max ? item.max : hasMax ? maxVal : item.value ? item.value : 0 }
        })
        this.$changeOptionsEV(newIndicator, "chartOption.radar.indicator", false, null, this.myid, true)
        // 设置series数据
        let legendData = []
        for (let index = 0; index < result.length; index++) {
          // 组装series
          let seriesValuesTemp = simpleDeepClone(charOptionTemp.series[0].data[0].value)
          const radarData = result[index].data
          const values = radarData.map(item => item.value)
          seriesValuesTemp = values
          this.$changeOptionsEV(
            seriesValuesTemp,
            "chartOption.series.0.data." + index + ".value",
            false,
            null,
            this.myid,
            true
          )
          // 组装legend
          legendData.push(result[index].unit)
          const legendNameTemp = result[index].unit
          this.$changeOptionsEV(
            legendNameTemp,
            "chartOption.series.0.data." + index + ".name",
            false,
            null,
            this.myid,
            true
          )
        }
        this.$changeOptionsEV(legendData, "chartOption.legend.data", false, null, this.myid, true)
      } else if (charOptionTemp.series[0].type === "gauge") {
        //  刻度图单独处理，只去第一条数据
        let data = result[0].data[0]
        let progress = data.value / data.max
        let dataVal = [
          {
            name: data.key,
            value: data.value
          }
        ]
        progress.toFixed(2)
        this.$changeOptionsEV(data.max, "chartOption.series.0.max", false, null, this.myid, true)
        this.$changeOptionsEV(dataVal, "chartOption.series.1.data", false, null, this.myid, true)
        this.$changeOptionsEV(
          progress,
          "chartOption.series.1.axisLine.lineStyle.color.0.0",
          false,
          null,
          this.myid,
          true
        )
      } else if (charOptionTemp.series[0].type === "liquidFill") {
        //   水球图需要单独处理数据，只去第一组数据
        let liquidFillData = result[0].data
        let tempData = []
        let hasMax = false,
          maxVal = 0
        if (result[0].max) {
          hasMax = true
          maxVal = result[0].max
        }else if(charOptionTemp.maxAutoSet){
          hasMax = true
          maxVal = charOptionTemp.maxAutoValue
        }
        //水位图的初始化颜色同步
        let oldData = charOptionTemp.series[0].data,
          showRealVal = false
        if (charOptionTemp.pluginName.indexOf("formatterValToNumber") > -1) {
          showRealVal = true
        }
        liquidFillData.forEach((data, index) => {
          let progress = 0
          let max = data.max || 100
          if (data.max && data.max !== 0) {
            progress = data.value / data.max
          } else if (hasMax) {
            max = maxVal
            progress = data.value / max
          }else if(!hasMax){
            progress = data.value / max
          }
          let oldItemStyle
          if (oldData[index] && oldData[index].itemStyle) {
            oldItemStyle = oldData[index].itemStyle
          } else if (oldData[0] && oldData[0].itemStyle) {
            oldItemStyle = oldData[0].itemStyle
          }
          let realValStr = {}
          if (showRealVal) {
            realValStr = {
              realValue: data.value
            }
          }
          tempData.push({
            max: max,
            value: progress,
            name: data.key,
            itemStyle: oldItemStyle,
            ...realValStr
          })
        })
        this.$changeOptionsEV(tempData, "chartOption.series.0.data", false, null, this.myid, true)
      } else if (charOptionTemp.series[0].type === "surface") {
        if (result.length < 1) {
          console.log("result为空", result)
          this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
          return
        } else {
          this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
        }
        // 3d饼图
        let pie3DData = result[0].data
        let total = 0,
          startRatio = 0,
          endRatio = 0,
          tempData1 = [],
          legendData = []
        let tempLen = pie3DData.length - charOptionTemp.series.length + 1
        let localDataLength = charOptionTemp.series.length
        if (charOptionTemp.series.length - 1 < pie3DData.length) {
          for (let i = 0; i < tempLen; i++) {
            let firstData = simpleDeepClone(charOptionTemp.series[0])
            firstData.itemStyle.color = defaultColor[(localDataLength - 1 + i) % defaultColor.length]
            if (
              Array.isArray(charOptionTemp.series[charOptionTemp.series.length - 1].color) &&
              charOptionTemp.series[charOptionTemp.series.length - 1].color.length > 0
            ) {
              charOptionTemp.series[charOptionTemp.series.length - 1].color.splice(
                charOptionTemp.series.length - 1,
                0,
                defaultColor[(localDataLength - 1 + i) % defaultColor.length]
              )
            }
            charOptionTemp.series.splice(charOptionTemp.series.length - 1, 0, firstData)
          }
        } else if (charOptionTemp.series.length - 1 > pie3DData.length) {
          if (
            Array.isArray(charOptionTemp.series[charOptionTemp.series.length - 1].color) &&
            charOptionTemp.series[charOptionTemp.series.length - 1].color.length > 0
          ) {
            charOptionTemp.series[charOptionTemp.series.length - 1].color.splice(pie3DData.length, Math.abs(tempLen))
          }
          charOptionTemp.series.splice(pie3DData.length, Math.abs(tempLen))
        }
        pie3DData.forEach((data, index) => {
          total += parseInt(data.value)
          tempData1.push({
            value: data.value,
            name: data.key
          })
        })
        pie3DData.forEach((data, index) => {
          endRatio = startRatio + data.value / total
          legendData.push(data.key)
          charOptionTemp.series[index].name = data.key
          charOptionTemp.series[index].pieData.name = data.key
          charOptionTemp.series[index].pieData.startRatio = startRatio.toFixed(2)
          charOptionTemp.series[index].pieData.endRatio = endRatio.toFixed(2)
          charOptionTemp.series[index].pieData.value = (endRatio - startRatio) * 10
          startRatio = endRatio
        })
        charOptionTemp.legend.data = legendData
        charOptionTemp.series[pie3DData.length].data = tempData1
        this.$changeOptionsEV(legendData, "chartOption.legend.data", false, null, this.myid, true)
        this.$changeOptionsEV(charOptionTemp.series, "chartOption.series", false, null, this.myid, true)
      } else if (
        charOptionTemp.series[0].type === "pie" &&
        charOptionTemp.series.length > 1 &&
        charOptionTemp.series[1].type === "gauge"
      ) {
        const localDataLength = charOptionTemp.series[0].data.length / 2 // localData数据长度会变，所以在外面初始化
        let localData = charOptionTemp.series[0]
        let lastData = localData.data[localData.data.length - 1]
        if (result[0].data.length > localDataLength) {
          for (let j = 0; j < result[0].data.length - localDataLength; j++) {
            const cloneDataItem = simpleDeepClone(localData.data[0])
            // 设置默认样色
            if (
              cloneDataItem &&
              cloneDataItem.hasOwnProperty("itemStyle") &&
              JSON.stringify(cloneDataItem.itemStyle) !== "{}"
            ) {
              if (typeof cloneDataItem.itemStyle.color === "object") {
                cloneDataItem.itemStyle.color.colorStops[0].color =
                  defaultGradientColor[(localDataLength + j) % defaultGradientColor.length][0]
                cloneDataItem.itemStyle.color.colorStops[1].color =
                  defaultGradientColor[(localDataLength + j) % defaultGradientColor.length][1]
              } else {
                cloneDataItem.itemStyle.color = defaultColor[(localDataLength + j) % defaultColor.length]
              }
            }
            localData.data.splice(j, 0, cloneDataItem)
            localData.data.push(lastData)
          }
        } else if (result[0].data.length < localDataLength) {
          for (let j = 0; j < localDataLength - result[0].data.length; j++) {
            localData.data.splice(result[0].data.length, 1)
          }
        }
        const dataItem = result[0].data
        for (let n = 0; n < dataItem.length; n++) {
          localData.data[n].value = dataItem[n].value
          if (localData.data[n].name) {
            localData.data[n].name = dataItem[n].key
          }
        }
        this.$changeOptionsEV(localData, "chartOption.series.0", false, null, this.myid, true)
      } else {
        const { localData, legendData, axisData } = assembleLocalData.call(
          this,
          chartOption,
          charOptionTemp.series,
          result,
          defaultGradientColor,
          defaultColor
        )
        // 多组数据的时候，关闭掉自动排序

        if (localData.length > 1 && localData[0].hasOwnProperty("realtimeSort")) {
          localData.forEach(item => {
            item.realtimeSort = false
          })
        }
        // 饼图图例不需要处理
        if (charOptionTemp.series[0].type !== "pie") {
          this.$changeOptionsEV(legendData, "chartOption.legend.data", false, null, this.myid, true)
        }
        if (charOptionTemp.xAxis && charOptionTemp.xAxis.type === "category") {
          this.$changeOptionsEV(axisData, "chartOption.xAxis.data", false, null, this.myid, true)
        } else if (charOptionTemp.yAxis && charOptionTemp.yAxis.type === "category") {
          this.$changeOptionsEV(axisData, "chartOption.yAxis.data", false, null, this.myid, true)
        } else if (charOptionTemp.radiusAxis && charOptionTemp.radiusAxis.type === "category") {
          this.$changeOptionsEV(axisData, "chartOption.radiusAxis.data", false, null, this.myid, true)
        }
        this.$changeOptionsEV(localData, "chartOption.series", false, null, this.myid, true)
      }
    }
  } else if (this.request_prefix !== "bigScreen") {
    // 2.0图表接口报错显示报错码
    let errorCode = getErrorCode(res.data.message)
    console.log("errorCode :>>", errorCode, this.myid)
    this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
    this.$changeOptionsEV(errorCode, "errorCode", false, null, this.myid, true)
  }
}
